/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { stopListItemRequestSchema } from "./stopListItemRequestSchema.ts";

export const updateStopListRequestSchema = z.object({
	groupId: z.uuid(),
	plugin_key: z.string().min(1),
	items: z.array(stopListItemRequestSchema),
});
